import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListStatusCell } from './emsp-bo-invoice-list-status.cell';
import { EmspBoInvoiceListStatusHeader } from './emsp-bo-invoice-list-status.header';

export const EmspBoInvoiceListStatusColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['status']
> = {
  enableSorting: false,
  header: EmspBoInvoiceListStatusHeader,
  cell: EmspBoInvoiceListStatusCell,
};
